import '@fontsource-variable/jost/wght.css'
import '@fontsource/carlito/400.css'
import '@fontsource/carlito/700.css'
import './index.scss'
import 'virtual:svg-icons-register'
import '#lib/i18n'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

try {
  localStorage.removeItem('wijmobiel_access_token')
} catch {
  // localStorage can be unavailable (privacy mode, disabled storage)
}

// Tag <html> with the OS so CSS can compensate for platform font-metric differences
if (navigator.userAgent.includes('Windows')) document.documentElement.dataset.os = 'windows'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find root element')

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
